import styled from 'styled-components';

export const ResetPasswordContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  > div {
    max-width: 500px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > svg {
    margin-bottom: 32px;
  }

  button {
    display: flex;
    width: 100%;
  }

  .InfoAlert {
    width: 100%;
    margin-bottom: 24px;
  }

  .WarningAlert {
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const Title = styled.h1`
  color: var(--color-black-primary);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 12px;
  width: 100%;
  text-align: center;
`;

export const Description = styled.p`
  color: var(--color-gray-100);
  font-size: 14px;
  margin-bottom: 24px;
  width: 100%;
`;

export const WarningList = styled.ul`
  margin: 8px 0 0 18px;
  display: block;
  list-style: disc;

  li {
    color: var(--color-gray-100);
    font-size: 13px;
    line-height: 20px;
    margin-bottom: 2px;
  }
`;

export const RecoverPasswordButton = styled.button`
  border: none;
  background: transparent;
  color: var(--color-blue-primary);
  font-size: 14px;
  margin-bottom: 20px;
  justify-content: flex-end;
`;

export const SubmitButtonWrapper = styled.div`
  width: 100%;
  margin-top: 32px;
`;

export const ErrorMessage = styled.p`
  color: var(--color-red-100);
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px;
  width: 100%;
`;

export const SuccessMessage = styled.p`
  color: var(--color-white-primary);
  font-size: 17px;
  line-height: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 16px;
  width: 100%;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% + 80px);
  margin: -40px -40px -40px;
  background: var(--color-black-primary);
  border-radius: 8px;
  overflow: hidden;
`;

export const SuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 55px 96px 0;

  > svg {
    width: 100%;
    max-width: 289px;
    margin-bottom: 16px;
  }
`;

export const SuccessActions = styled.div`
  width: 100%;
  padding: 24px 48px;
  background: var(--color-black-primary);
`;

export const RulesContainer = styled.ul`
  display: block;
  width: 100%;
  margin: 0 0 20px;
  padding-left: 20px;
`;

export const RuleItem = styled.li<{ isValid: boolean }>`
  color: ${({ isValid }) => (isValid ? 'var(--color-green-100)' : 'var(--color-gray-100)')};
  font-size: 13px;
  margin-bottom: 8px;
`;
